var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLead(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24.808,
    height: 16.122,
    viewBox: "0 0 24.808 16.122",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#0b6462;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-2.215 -7.748)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M21.043,20.152c-.619-.221-1.63-.232-2.077-.4A2.935,2.935,0,0,1,18,19.3a5.941,5.941,0,0,1-.16-1.575,2.544,2.544,0,0,0,.547-.774,8.6,8.6,0,0,0,.265-1.519s.365.155.508-.575c.122-.63.354-.961.293-1.425s-.32-.354-.32-.354a4.137,4.137,0,0,0,.32-2.066,3.306,3.306,0,0,0-3.569-3.265,3.318,3.318,0,0,0-3.575,3.265,4.2,4.2,0,0,0,.315,2.066s-.26-.111-.32.354.166.8.293,1.425c.144.735.508.575.508.575a8.68,8.68,0,0,0,.265,1.519,2.544,2.544,0,0,0,.547.774,5.941,5.941,0,0,1-.16,1.575,2.825,2.825,0,0,1-.961.442c-.442.171-1.453.193-2.077.414a3.9,3.9,0,0,0-2.531,3.713H23.568A3.892,3.892,0,0,0,21.043,20.152Z",
    transform: "translate(-1.28 0)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M8.21,18.2a3.751,3.751,0,0,0,1.845-.514c-.856-1.3-.392-2.812-.569-4.227a2.331,2.331,0,0,0-2.58-2.254H6.884a2.338,2.338,0,0,0-2.558,2.254c-.177,1.409.315,3.094-.564,4.227a3.471,3.471,0,0,0,1.851.459h0a2.8,2.8,0,0,1-.055.928,1.4,1.4,0,0,1-.663.3,12.82,12.82,0,0,0-1.431.4,2.326,2.326,0,0,0-1.249,2.055H6.652A3.969,3.969,0,0,1,8.42,20.186,3.71,3.71,0,0,1,9.784,19.9s.21-.332-.481-.459a4.71,4.71,0,0,1-1.061-.37C8.138,18.949,8.21,18.2,8.21,18.2Z",
    transform: "translate(0 -0.741)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M25.653,18.2a3.751,3.751,0,0,1-1.845-.514c.856-1.3.392-2.812.569-4.227a2.331,2.331,0,0,1,2.58-2.254h.022a2.338,2.338,0,0,1,2.558,2.254c.177,1.409-.315,3.094.564,4.227a3.471,3.471,0,0,1-1.851.459h0a2.8,2.8,0,0,0,.055.928,1.4,1.4,0,0,0,.663.3,12.82,12.82,0,0,1,1.431.4,2.326,2.326,0,0,1,1.249,2.055H27.211a3.969,3.969,0,0,0-1.768-1.646,3.71,3.71,0,0,0-1.365-.287s-.21-.332.481-.459a4.71,4.71,0,0,0,1.061-.37C25.725,18.949,25.653,18.2,25.653,18.2Z",
    transform: "translate(-4.625 -0.741)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLead);
export default __webpack_public_path__ + "static/media/lead.7f47af52e045b781248949c9a5abd477.svg";
export { ForwardRef as ReactComponent };